import { States } from 'safe'
import {
  CLEAN_PURCHASES,
  PurchasesTypes,
  SET_PURCHASES,
} from '../actions/actionTypes'

export const initialState: States.Purchases = {
  purchases: [],
  numberOfPages: 0,
}

export default (
  state = initialState,
  action: PurchasesTypes
): States.Purchases => {
  switch (action.type) {
    case SET_PURCHASES:
      return {
        purchases: action.payload.purchases,
        numberOfPages: action.payload.numberOfPages,
      }
    case CLEAN_PURCHASES:
      return {
        purchases: [],
        numberOfPages: 0,
      }
    default:
      return state
  }
}
